// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-password-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 550px;
  /* Responsive Design */
  /* For very small mobile devices */
}
.forgot-password-page .forgot-password-container {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.forgot-password-page .forgot-password-container h2 {
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
}
.forgot-password-page .forgot-password-container .subtext {
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
}
.forgot-password-page .forgot-password-container .forgot-password-form .form-group {
  margin-bottom: 20px;
  text-align: left;
}
.forgot-password-page .forgot-password-container .forgot-password-form .form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}
.forgot-password-page .forgot-password-container .forgot-password-form .form-group input {
  width: 100%;
  padding: 12px;
  background-color: rgba(188, 187, 193, 0.2);
  border-radius: 5px;
  font-size: 14px;
  box-sizing: border-box;
  border: 1px solid transparent;
  transition: border-color 0.3s;
}
.forgot-password-page .forgot-password-container .forgot-password-form .form-group input:focus {
  outline: none;
  border-color: var(--pmu-primary);
}
.forgot-password-page .forgot-password-container .forgot-password-form .back-to-login {
  text-align: right;
  margin-bottom: 20px;
}
.forgot-password-page .forgot-password-container .forgot-password-form .back-to-login a {
  color: var(--pmu-primary);
  text-decoration: none;
  font-size: 14px;
}
.forgot-password-page .forgot-password-container .forgot-password-form .back-to-login a:hover {
  text-decoration: underline;
}
.forgot-password-page .forgot-password-container .forgot-password-form .reset-button {
  width: 100%;
  padding: 14px;
  background-color: var(--pmu-primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-weight: 500;
}
.forgot-password-page .forgot-password-container .forgot-password-form .reset-button:hover {
  background-color: rgb(103.2727272727, 32.7272727273, 103.2727272727);
}
.forgot-password-page .forgot-password-container .forgot-password-form .reset-button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.forgot-password-page .forgot-password-container .terms-text {
  font-size: 12px;
  color: #666;
  margin-top: 20px;
}
.forgot-password-page .forgot-password-container .terms-text a {
  color: #333;
  text-decoration: underline;
}
.forgot-password-page .footer {
  margin-top: 20px;
  font-size: 12px;
  color: #666;
  text-align: center;
}
.forgot-password-page .footer p {
  margin: 0;
}
@media (max-width: 768px) {
  .forgot-password-page {
    width: 100%;
  }
  .forgot-password-page .forgot-password-container {
    max-width: 100%;
    text-align: start;
  }
  .forgot-password-page .forgot-password-container h2 {
    font-size: 22px;
  }
  .forgot-password-page .forgot-password-container .subtext {
    font-size: 13px;
    margin-bottom: 25px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .form-group {
    margin-bottom: 18px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .form-group label {
    font-size: 13px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .form-group input {
    padding: 10px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .reset-button {
    padding: 12px;
    font-size: 15px;
  }
}
@media (max-width: 480px) {
  .forgot-password-page {
    width: 100%;
  }
  .forgot-password-page .forgot-password-container {
    border-radius: 8px;
  }
  .forgot-password-page .forgot-password-container h2 {
    font-size: 20px;
  }
  .forgot-password-page .forgot-password-container .subtext {
    font-size: 12px;
    margin-bottom: 20px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .form-group {
    margin-bottom: 15px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .form-group label {
    margin-bottom: 6px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .form-group input {
    padding: 10px;
    font-size: 13px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .back-to-login {
    margin-bottom: 15px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .back-to-login a {
    font-size: 13px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .reset-button {
    padding: 10px;
    font-size: 14px;
  }
  .forgot-password-page .forgot-password-container .terms-text {
    font-size: 11px;
    margin-top: 15px;
  }
  .forgot-password-page .footer {
    margin-top: 15px;
    font-size: 11px;
  }
}
@media (max-width: 320px) {
  .forgot-password-page .forgot-password-container {
    padding: 20px 15px;
  }
  .forgot-password-page .forgot-password-container h2 {
    font-size: 18px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .form-group input {
    padding: 8px;
  }
  .forgot-password-page .forgot-password-container .forgot-password-form .reset-button {
    padding: 10px;
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/authpage/authsubfolders/login/forgotPasswordForm.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EA6GA,sBAAA;EA6FA,kCAAA;AAvMF;AADE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AAGJ;AADI;EACE,eAAA;EACA,mBAAA;EACA,WAAA;AAGN;AAAI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAEN;AAEM;EACE,mBAAA;EACA,gBAAA;AAAR;AAEQ;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAAV;AAGQ;EACE,WAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;EACA,6BAAA;AADV;AAGU;EACE,aAAA;EACA,gCAAA;AADZ;AAMM;EACE,iBAAA;EACA,mBAAA;AAJR;AAMQ;EACE,yBAAA;EACA,qBAAA;EACA,eAAA;AAJV;AAMU;EACE,0BAAA;AAJZ;AASM;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;AAPR;AASQ;EACE,oEAAA;AAPV;AAUQ;EACE,yBAAA;EACA,mBAAA;AARV;AAaI;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAXN;AAaM;EACE,WAAA;EACA,0BAAA;AAXR;AAgBE;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,SAAA;AAdN;AAmBE;EAlHF;IAmHI,WAAA;EAhBF;EAkBE;IACE,eAAA;IACA,iBAAA;EAhBJ;EAkBI;IACE,eAAA;EAhBN;EAmBI;IACE,eAAA;IACA,mBAAA;EAjBN;EAqBM;IACE,mBAAA;EAnBR;EAqBQ;IACE,eAAA;EAnBV;EAsBQ;IACE,aAAA;EApBV;EAwBM;IACE,aAAA;IACA,eAAA;EAtBR;AACF;AA2BE;EAvJF;IAwJI,WAAA;EAxBF;EA0BE;IACE,kBAAA;EAxBJ;EA0BI;IACE,eAAA;EAxBN;EA2BI;IACE,eAAA;IACA,mBAAA;EAzBN;EA6BM;IACE,mBAAA;EA3BR;EA6BQ;IACE,kBAAA;EA3BV;EA8BQ;IACE,aAAA;IACA,eAAA;EA5BV;EAgCM;IACE,mBAAA;EA9BR;EAgCQ;IACE,eAAA;EA9BV;EAkCM;IACE,aAAA;IACA,eAAA;EAhCR;EAoCI;IACE,eAAA;IACA,gBAAA;EAlCN;EAsCE;IACE,gBAAA;IACA,eAAA;EApCJ;AACF;AAwCE;EACE;IACE,kBAAA;EAtCJ;EAwCI;IACE,eAAA;EAtCN;EA2CQ;IACE,YAAA;EAzCV;EA6CM;IACE,aAAA;IACA,eAAA;EA3CR;AACF","sourcesContent":[".forgot-password-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 550px;\n\n  .forgot-password-container {\n    width: 100%;\n    text-align: center;\n    margin-top: 30px;\n\n    h2 {\n      font-size: 24px;\n      margin-bottom: 10px;\n      color: #333;\n    }\n\n    .subtext {\n      font-size: 14px;\n      color: #666;\n      margin-bottom: 30px;\n    }\n\n    .forgot-password-form {\n      .form-group {\n        margin-bottom: 20px;\n        text-align: left;\n\n        label {\n          display: block;\n          margin-bottom: 8px;\n          font-size: 14px;\n          color: #333;\n        }\n\n        input {\n          width: 100%;\n          padding: 12px;\n          background-color: #bcbbc133;\n          border-radius: 5px;\n          font-size: 14px;\n          box-sizing: border-box;\n          border: 1px solid transparent;\n          transition: border-color 0.3s;\n\n          &:focus {\n            outline: none;\n            border-color: var(--pmu-primary);\n          }\n        }\n      }\n\n      .back-to-login {\n        text-align: right;\n        margin-bottom: 20px;\n\n        a {\n          color: var(--pmu-primary);\n          text-decoration: none;\n          font-size: 14px;\n\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n\n      .reset-button {\n        width: 100%;\n        padding: 14px;\n        background-color: var(--pmu-primary);\n        color: #fff;\n        border: none;\n        border-radius: 8px;\n        font-size: 16px;\n        cursor: pointer;\n        transition: background-color 0.3s;\n        font-weight: 500;\n\n        &:hover {\n          background-color: darken(#8e2d8e, 10%);\n        }\n\n        &:disabled {\n          background-color: #cccccc;\n          cursor: not-allowed;\n        }\n      }\n    }\n\n    .terms-text {\n      font-size: 12px;\n      color: #666;\n      margin-top: 20px;\n\n      a {\n        color: #333;\n        text-decoration: underline;\n      }\n    }\n  }\n\n  .footer {\n    margin-top: 20px;\n    font-size: 12px;\n    color: #666;\n    text-align: center;\n\n    p {\n      margin: 0;\n    }\n  }\n\n  /* Responsive Design */\n  @media (max-width: 768px) {\n    width: 100%;\n\n    .forgot-password-container {\n      max-width: 100%;\n      text-align: start;\n\n      h2 {\n        font-size: 22px;\n      }\n\n      .subtext {\n        font-size: 13px;\n        margin-bottom: 25px;\n      }\n\n      .forgot-password-form {\n        .form-group {\n          margin-bottom: 18px;\n\n          label {\n            font-size: 13px;\n          }\n\n          input {\n            padding: 10px;\n          }\n        }\n\n        .reset-button {\n          padding: 12px;\n          font-size: 15px;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 480px) {\n    width: 100%;\n\n    .forgot-password-container {\n      border-radius: 8px;\n\n      h2 {\n        font-size: 20px;\n      }\n\n      .subtext {\n        font-size: 12px;\n        margin-bottom: 20px;\n      }\n\n      .forgot-password-form {\n        .form-group {\n          margin-bottom: 15px;\n\n          label {\n            margin-bottom: 6px;\n          }\n\n          input {\n            padding: 10px;\n            font-size: 13px;\n          }\n        }\n\n        .back-to-login {\n          margin-bottom: 15px;\n\n          a {\n            font-size: 13px;\n          }\n        }\n\n        .reset-button {\n          padding: 10px;\n          font-size: 14px;\n        }\n      }\n\n      .terms-text {\n        font-size: 11px;\n        margin-top: 15px;\n      }\n    }\n\n    .footer {\n      margin-top: 15px;\n      font-size: 11px;\n    }\n  }\n\n  /* For very small mobile devices */\n  @media (max-width: 320px) {\n    .forgot-password-container {\n      padding: 20px 15px;\n\n      h2 {\n        font-size: 18px;\n      }\n\n      .forgot-password-form {\n        .form-group {\n          input {\n            padding: 8px;\n          }\n        }\n\n        .reset-button {\n          padding: 10px;\n          font-size: 13px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
